export default {
    title: 'Co May Gao',
    purchaseOrders: 'Purchase orders',
    purchaseOrder: 'Purchase order',
    material: 'Material',
    supplier: 'Supplier',
    amount: 'Amount',
    capacity: 'Capacity',
    vehicleNo: 'Vehicle no',
    container: 'Container',
    containers: 'Containers',
    searchContainers: 'Search containers',
    save: 'Save',
    username: 'Username',
    password: 'Password',
    signIn: 'Sign in',
    signOut: 'Sign out',
    remainingAmount: 'Remaining amount',
    information: 'Information',
    space: 'Space',
    basicInfo: 'Basic information',
    advancedInfo: 'Advanced information',
    language: 'Language',
    transferOrders: 'Transfer orders',
    containerMoving: 'Container moving',
    action: 'Action',
    shift: 'Shift',
    transferFrom: 'Transfer from',
    transferTo: 'Transfer to',
    having: 'Having',
    mosManagement: 'Manufacture orders',
    packing: 'Packing',
    packingUnit: 'Packing unit',
    saleOrder: 'Sale orders',
    saleOrderDetails: 'Sale order details',
    customer: 'Customer',
    addCustomer: 'Add new customer',
    dashboard: 'Dashboard',
    field: 'Field',
    seekOrigin: 'Seek origin',
    close: 'Close',
    rememberMe: 'Remember me',
    check: 'Check',
    checkFormula: 'Check the formula',
    formulaDetail: 'Formula details',
    editFormula: 'Edit formula',
    addMore: 'Add more',
    remove: 'Remove',
    name: 'Name',
    noRecords: 'There is no records',
    ShiftUsers: 'Shift users',
    documents: 'Documents',
    inventory: 'Inventory',
    chooseMaterial: 'Choose the material, suppliment..',
    chooseContainerOrTree: 'Choose the container',
    next: 'Next',
    mixFrom: 'Mix from',
    suppliment: 'Suppliment',
    supplimentOrder: 'Suppliment orders',
    moMaterial: 'Product name and suppliment',
    finishedProducts: 'Finished products',
    riceAndSuppliment: 'Rice and suppliment',
    cardboard_size: 'Cardboard size',
    cover_amount: 'Cover amount',
    inventory_covers: 'Inventory covers',
    transferCovers: 'Transfer covers',
    inventoryPlace: 'Inventory',
    cover: 'Cover',
    coverCardBoard: 'Cardboard',
    covers: 'Covers',
    lo: 'Lo',
    size: 'Size',
    miss: 'Miss',
    totalMiss: 'Total miss',
    addNewSaleOrder: 'Add new sale order',
    listofSo: 'List sale orders',
    employee: 'Employee',
    addSupplier: 'Add supplier',
    inputSupplierName: 'Fill supplier name',
    inputCustomerName: 'Fill customer name',
    addCommonSuppliment: 'Add common suppliment',
    processing: 'Processing...',
    mocode: 'Mo Code',
    product: 'Product',
    price: 'Price',
    soVehicle: 'Container',
    listOrders: 'List orders',
    style: 'Style',
    expectedExport: 'Expected export',
    retailCustomer: 'Retail customer',
    changeview: 'Change view',
    whoyouare: 'Who you are?',
    fillCurrentAmount: 'Fill current amount',
    accordingActualFigures: 'According to actual figures',
    lineColor: 'Line color',
    fromDate: 'From date',
    toDate: 'To date',
    exportedAt: 'Exported at',
    socode: 'So code',
    viewMore: 'View more',
    doesNotExport: 'Does not exported',
    totalValue: 'Total value',
    total_liabilities: 'Total liabilities',
    fullname: 'Full name',
    address: 'Address',
    shipping_unit: 'Shipping unit',
    samecont: 'Same vehicle',
    notes: 'Notes',
    company_name: 'Company name',
    vehicleOwner: 'Vehicle owner',
    solo: 'Số lô',
    pocode: 'Po Code',
    device: 'Device',
    bin: 'Bin/Location',
    for_internal: 'For internal',
    company: {
        description: 'Cỏ May Automation (CMA) đem đến các giải pháp giúp doanh nghiệp tối ưu hóa chi phí sản xuất và vận hành dựa trên nền tảng tri thức và công nghệ.',
    },
    errors: {
        title: 'Error',
        login: 'Sign in error',
        required: 'This field is required',
        requiredAll: 'Please fill the information in this form',
        inputAmount: 'Remaining amount of the containers is not enough for input amount',
        outputAmount: 'Remaining amount of the containers is not enough for output amount',
        inputError: 'The number of outputs cannot be less than the number of inputs',
        requiredCode: 'Code is required',
        greaterZero: 'The number must be greater than 0',
        requiredSolo: 'Solo is required',
    },
    success: {
        addPO: 'Purchase order was created',
        addTO: 'Transfer order was created',
        addMO: 'Manufacture order was created',
        addSO: 'Sale order was created',
        addSupplier: 'Supplier was created',
        addSuppliment: 'Suppliment was added',
        addSODetail: 'Sale order detail was created',
        editShiftUser: 'Shift user was updated',
        transferCovers: 'Transfer cover was created',
        addCustomer: 'Customer was added',
        changeRole: 'Your role was saved',
        changeCapacity: 'Capacity was changed',
    },
    msg: {
        noFormulaDetails: 'There is no formula matching this material',
        confirmInputSuppliment: 'Do you want to add more suppliment',
    },
}